import type { ReactNode } from "react";
import {
	EmptyStatePanel,
	type MobileEmptyStateReason,
} from "./StatePanel.tsx";

type Props = {
	action?: ReactNode;
	children: ReactNode;
	reason?: MobileEmptyStateReason;
	title: ReactNode;
};

export const EmptyState = ({ action, children, reason, title }: Props) => {
	return (
		<EmptyStatePanel action={action} emptyReason={reason} title={title}>
			{children}
		</EmptyStatePanel>
	);
};
